import React from "react";
import { IconChevronRight } from "@tabler/icons-react";
import { get, map } from "lodash";

const LEVEL_LABELS_BY_COUNTRY: Record<string, string[]> = {
  sv: ["Departamentos", "Municipios", "Distritos"],
  gt: ["Departamentos", "Municipios", "Aldeas"],
  pa: ["Provincias", "Distritos", "Corregimientos"],
};

const getLevelLabel = (country: string, level: number): string => {
  const labels = LEVEL_LABELS_BY_COUNTRY[country] ?? LEVEL_LABELS_BY_COUNTRY.sv;
  return get(labels, level - 1, `Nivel ${level}`);
};

interface TrailItem {
  level: number;
  id: number;
  name: string;
}

interface BreadcrumbsProps {
  country: string;
  activeLevel: number;
  trail: TrailItem[];
  onNavigate: (level: number) => void;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ country, activeLevel, trail, onNavigate }) => {
  // Root → trail names (drill-down parents) → current level label (active)
  const items = [
    { label: "Mapa de precios Propi", targetLevel: 1 },
    ...map(trail, (t) => ({ label: t.name, targetLevel: t.level + 1 })),
    { label: getLevelLabel(country, activeLevel), targetLevel: activeLevel },
  ];

  return (
    <nav
      aria-label="Breadcrumb"
      className="flex flex-wrap items-center gap-2 text-xs md:text-sm p-6 [text-shadow:0_0_2px_#002412,0_2px_12px_#002412,0_0_6px_#002412]"
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <React.Fragment key={`${item.targetLevel}-${index}`}>
            {isLast ? (
              <span className="text-[#05EE84] select-none [text-shadow:0_0_2px_#002412,0_2px_12px_#002412,0_0_6px_#002412]">{item.label}</span>
            ) : (
              <button
                type="button"
                className={`text-white/80 hover:text-white transition-colors select-none [text-shadow:0_0_2px_#002412,0_2px_12px_#002412,0_0_6px_#002412] ${index === 0 ? "hidden md:inline" : ""}`}
                onClick={() => onNavigate(item.targetLevel - 1)}
              >
                {item.label}
              </button>
            )}
            {!isLast && (
              <span className={index === 0 ? "hidden md:inline-flex" : "inline-flex"} style={{ filter: "drop-shadow(0 0 2px #002412) drop-shadow(0 2px 12px #002412) drop-shadow(0 0 6px #002412)" }}>
                <IconChevronRight size={14} className="text-white/70" />
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
